module.exports = __webpack_public_path__ + "static/media/logo.78f42a2e.svg";